import React from "react";
import { Button, Header, Grid, Segment, GridRow } from "semantic-ui-react";
import { formatMoney } from "../../../../app/util/formatUtils";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { encryptValue } from "../../../../app/util/decryptUtil";

const styleSubHeader = {
  marginTop: "0.4em",
};
const PrestamoCard = ({ credito }) => {
  return (
    <Segment>
      <Grid stackable columns={2} style={{ marginTop: "0.1em" }}>
        <GridRow>
          <Grid.Column width={10}>
            <Header as="h4" color="blue" textAlign="left">
              {credito.nombreProducto}
              <Header.Subheader style={styleSubHeader}>
                {`Número de préstamo: ${credito.credito}`}
              </Header.Subheader>
              <Header.Subheader style={styleSubHeader}>
                {`Monto de préstamo: ${credito.nombreMoneda} ${formatMoney(
                  credito.importe
                )}`}
              </Header.Subheader>
            </Header>
          </Grid.Column>
          <Grid.Column width={4}>
            <GridRow>
              <Button
                color="yellow"
                size="large"
                content="Ver detalle"
                fluid
                as={Link}
                to={`prestamos/${encryptValue(credito.credito)}`}
              />
              {/* <Button
                color="yellow"
                size="large"
                content="Ver detalle"
                fluid
                as={Link}
                to={`prestamos/${credito.credito}`}
              /> */}
            </GridRow>
          </Grid.Column>
        </GridRow>
      </Grid>
    </Segment>
  );
};

PrestamoCard.propTypes = {
  credito: PropTypes.object.isRequired,
};

export default PrestamoCard;
